import HttpRequest from "@api/httpRequest";
import { RequestData } from "@models/axios";
import getPropByString from "@utils/get";

const getUrl = (): string => {
  return `/packages`;
};

function api() {
  return {
    getList: (data: RequestData) => {
      const { params = {} } = data;
      return HttpRequest.get(getUrl(), {
        params: params
      });
    },
    getApproaches : (data: RequestData) => {
      const { params = {} } = data;
      return HttpRequest.get(`${getUrl()}/${params.id}/approaches`, {
        params: params
      });
    },
  };
}

export default api();
